import React, { useEffect, useContext } from "react";
// import { useForm } from 'react-hook-form';

import {
  Grid,
  Card,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import _ from "lodash";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import userContext from "contexts/userContext";

export default function LivePreviewExample(props) {
  const intl = useIntl();
  const { role, setRole, locale } = useContext(userContext);
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const [valid, setValid] = React.useState(false);
  const [values, setValues] = React.useState({
    id: "",
    nom: "",
    tel: "",
    email: "",
    adresse: "",
    ville: "",
  });
  const [errors, setErrors] = React.useState({});
  const [helpers, setHelpers] = React.useState({});
  // const [submitting, setSubmitting] = useState(false);
  const [createMode, setCreateMode] = React.useState(false);
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors }
  // } = useForm;
  const [villes, setVilles] = React.useState([]);
  const [villesR, setVillesR] = React.useState([]);
  const [openF, setOpenF] = React.useState(false);
  const [openT, setOpenT] = React.useState(false);
  const [fournisseur, setFournisseur] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const loadingF = openF && fetching;
  const loadingT = openT && fetching;

  useEffect(() => {
    console.log("role changed(FOURNISSEUR), role : ", role);
    if (
      role &&
      role.user &&
      role.user.company &&
      role.user.company.account_local === "1" &&
      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
        role.user.roles[0].name,
      ) &&
      !role.user.company.special_authorization &&
      !role.user.company.consignataire &&
      !role.user.company.forwarding_agent
    ) {
      //CHECK IF EXISTS
      (async () => {
        try {
          const response = await fetch(
            props.api +
              "/api/foreign_shippers?name=" +
              role.user.company.raison_sociale,
            requestOptions,
          );
          let _shippers = await response.json();
          _shippers = _shippers["hydra:member"];
          //EXISTS
          if (_shippers.length > 0) {
            console.log("EXISTS!!!!!!!!");
            setValues({
              uuid: _shippers[0].uuid,
              nom: _shippers[0].name,
              tel: _shippers[0].phone,
              email: _shippers[0].email,
              adresse: _shippers[0].address,
              ville: "",
            });
          } else {
            //DOESN'T EXIST
            console.log("DOESN'T EXIST!!!!!!!!");
            console.log("ELSE");
            setCreateMode(true);
            setValues({
              nom: role.user.company.raison_sociale,
              tel: role.user.company.telephone,
              email: role.user.company.email,
              adresse: role.user.company.address,
              ville: "",
            });
          }
        } catch {
          (e) => {
            console.log("an error occured, details : ", e);
          };
        }
      })();
    }
  }, [role]);

  const filter = createFilterOptions();

  const validateValues = () => {
    let errors = {};
    let helpers = {};
    // if (values.nom === '') {
    //   errors.nom = true;
    //   helpers.nom = 'Ce champ ne peut être vide';
    // }
    // if (values.tel !== "") {
    //   let regex = new RegExp(/^6(2|5|6|7|8|9)[0-9]{7}$/);
    //   if (props.sens === "export" && !regex.test(values.tel)) {
    //     errors.tel = true;
    //     helpers.tel = formatMessage(
    //       intl,
    //       "create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_phone"
    //     );
    //   }
    // }
    if (values.email !== "") {
      let regex = new RegExp(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      );
      if (!regex.test(values.email)) {
        errors.email = true;
        helpers.email = formatMessage(
          intl,
          "create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_email",
        );
      }
    }

    setErrors(errors);
    setHelpers(helpers);
  };

  const handleAutoCompleteChangeV = (event, newValue) => {
    if (newValue && typeof newValue["ville"] === "string") {
      setValues({ ...values, ["ville"]: newValue });
    } else {
      setValues({ ...values, ["ville"]: "" });
    }
  };

  useEffect(() => {
    if (!openF) {
      setFournisseur([]);
    }
  }, [openF]);

  useEffect(() => {
    //required fields
    let form_id = props.formId ?? "fournisseur-form";
    console.log("form_id : ", form_id);

    let form = document.getElementById(form_id);

    let validity = values.nom.length == 0 ? false : form.checkValidity();

    validity = validity && !Object.values(errors).includes(true);

    setValid(validity);
    console.log("name : ", values.nom, " setting validity to : ", validity);
    props.setValidity(validity);
    if (validity) {
      props.sendFournisseur(values);
      props.sendCreateMode(createMode);
    }
  }, [errors]);

  useEffect(() => {
    console.log("props cMode changed");
    console.log(props.cMode);
    setCreateMode(props.cMode);
  }, [props.cMode]);

  useEffect(() => {
    console.log("values changed, values : ", values);
  }, [values]);

  useEffect(() => {
    setFetching(false);
  }, [fournisseur]);

  useEffect(() => {
    setFetching(false);
  }, [villes]);

  useEffect(() => {
    console.log("props data changed");
    console.log(props.data);
    if (Object.keys(props.data).length > 0) {
      setValues(props.data);
    }
  }, [props.data]);

  const handleChange = (event) => {
    event.persist(event);

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleAutoCompleteChange = (event, newValue) => {
    if (newValue && typeof newValue["nom"] === "string") {
      let _values = newValue;
      setValues(_values);
      setCreateMode(false);
    } else if (newValue && newValue.inputValue) {
      let _values = {
        nom: newValue.inputValue,
        tel: "",
        email: "",
        adresse: "",
        ville: "",
      };
      setValues(_values);
      setCreateMode(true);
    } else {
      let _values = {
        nom: "",
        tel: "",
        email: "",
        adresse: "",
        ville: "",
      };
      setValues(_values);
      setCreateMode(false);
    }
    validateValues();
  };

  const debounceLoadFournisseur = _.debounce(async (search) => {
    try {
      const response = await fetch(
        props.api + "/api/foreign_shippers?name=" + search,
        requestOptions,
      );
      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      for (let s of _shippers) {
        options.push({
          uuid: s.uuid,
          nom: s.name,
          tel: s.phone,
          email: s.email,
          adresse: s.address,
          ville: "",
        });
      }
      setFournisseur(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  //DEBOUNCE LOAD TOWNS

  const debounceLoadVilles = _.debounce(async (search) => {
    try {
      const response = await fetch(
        props.api + "/api/towns?name=" + search,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      //
      for (let res of _shippers) {
        options.push({
          id: res["@id"],
          ville: res.name,
          pays: res.countryName,
          countryId: res.country,
        });
      }

      setVilles(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  useEffect(() => {
    validateValues();

    //required fields

    let form = document.getElementById("fournisseur-form");

    let validity = values.nom.length > 0;

    console.log("validity before : ", validity);

    let req_fields = createMode
      ? Object.keys(values).filter((v) => !["adresse"].includes(v))
      : Object.keys(values).filter((v) => ["nom"].includes(v));
    req_fields.map((rf) => {
      console.log("TEST OF A REQUIRED FIELD NAMED ", rf);
      console.log("val : ", values[rf]);
      let _eval = values[rf];
      if (_eval) {
        console.log("ok");
      } else {
        console.log("nok");
      }
      validity = validity && !!_eval;
      console.log("validity : ", validity);
    });

    console.log("validity after all checks : ", validity);

    validity = validity && !Object.values(errors).includes(true);

    setValid(validity);
    props.setValidity(validity);
    if (validity) {
      props.sendFournisseur(values);
      props.sendCreateMode(createMode);
    }
  }, [values]);

  useEffect(() => {
    let _villesR = [];

    fetch(
      props.api + "/api/towns?country.code=CM&itemsPerPage=40",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => result["hydra:member"])
      .then((result) => {
        console.log("RESULT OF API TOWNS IS : ", result);
        for (let res of result) {
          _villesR.push({
            id: res["@id"],
            ville: res.name,
            pays: "Cameroon",
            countryId: res.country,
          });
        }

        setVillesR(_villesR);
      });
  }, []);

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <Card className="p-4 mb-4">
      {/* -------------------------------------- Fournisseur ----------------------------------- */}
      <div className="font-size-lg font-weight-bold"> {props.headTitle}</div>

      <div>
        <form id={props.formId ?? "fournisseur-form"}>
          <Grid container direction="row" spacing={2} xs={12}>
            <Grid item xs={8} sm={6} md={3}>
              <FormControl
                fullWidth
                className={classes.margin}
                variant="outlined"
              >
                <Autocomplete
                  size="small"
                  open={openF}
                  onOpen={() => {
                    setOpenF(true);
                  }}
                  onClose={() => {
                    setOpenF(false);
                  }}
                  value={values.nom}
                  loadingText={formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_shippers_card_sender_label_searching",
                  )}
                  onChange={(event, newValue) =>
                    handleAutoCompleteChange(event, newValue)
                  }
                  loading={loadingF}
                  filterOptions={(options, params) => {
                    if (!loadingF) {
                      const filtered = filter(options, params);

                      // Suggest the creation of a new value
                      if (
                        params.inputValue !== "" &&
                        !loadingF &&
                        (filtered.length != 1 ||
                          params.inputValue.toLowerCase() !==
                            filtered[0].nom.toLowerCase())
                      ) {
                        console.log("create mode was : ", createMode);
                        filtered.push({
                          inputValue: params.inputValue,
                          text: "Créer " + params.inputValue,
                        });
                      }

                      return filtered;
                    } else {
                      return [];
                    }
                  }}
                  clearOnBlur
                  id="free-solo-with-text-demo"
                  options={fournisseur}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.text;
                    }
                    // Regular option

                    return option.nom;
                  }}
                  // renderOption={(option) => option.niu}
                  renderInput={
                    (params) =>
                      !(
                        role &&
                        role.user &&
                        role.user.company &&
                        role.user.company.account_local === "1" &&
                        ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                          role.user.roles[0].name,
                        ) &&
                        !role.user.company.special_authorization &&
                        !role.user.company.consignataire &&
                        !role.user.company.forwarding_agent
                      ) ? (
                        <TextField
                          fullWidth
                          {...params}
                          required
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_shippers_card_sender_label_name",
                          )}
                          error={errors.nom}
                          helperText={helpers.nom}
                          onChange={(event) => {
                            event.persist(event);
                            if (event.target.value.length > 2) {
                              if (!fetching) {
                                setFetching(true);
                              }

                              debounceLoadFournisseur(event.target.value);
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                          variant="outlined"
                        />
                      ) : (
                        <TextField
                          fullWidth
                          {...params}
                          required
                          label={formatMessage(
                            intl,
                            "create_besc_maritime_import_accordion_shippers_card_sender_label_name",
                          )}
                          error={errors.nom}
                          InputProps={{
                            readOnly:
                              role &&
                              role.user &&
                              role.user.company &&
                              role.user.company.account_local === "1" &&
                              [
                                "Chargeur Principal",
                                "Sous Compte Chargeur",
                              ].includes(role.user.roles[0].name) &&
                              !role.user.company.special_authorization &&
                              !role.user.company.consignataire &&
                              !role.user.company.forwarding_agent,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          helperText={helpers.nom}
                          onChange={(event) => {
                            event.persist(event);
                            if (event.target.value.length > 2) {
                              if (!fetching) {
                                setFetching(true);
                              }

                              debounceLoadFournisseur(event.target.value);
                            }

                            // if (event.target.value.length > 2) {
                            //   setFetching(true);

                            // }
                          }}
                          variant="outlined"
                        />
                        // <TextField
                        //   fullWidth
                        //   {...params}
                        //   label={formatMessage(
                        //     intl,
                        //     "create_besc_maritime_import_accordion_shippers_card_recipient_label_name"
                        //   )}
                        //   variant="outlined"
                        //   InputProps={{
                        //     readOnly:
                        //       props.partnersData.length > 0 ||
                        //       (role &&
                        //         role.user &&
                        //         role.user.company &&
                        //         role.user.company.account_local === "0" &&
                        //         !role.user.company.special_authorization && !role.user.company.forwarding_agent ),
                        //   }}
                        //   InputLabelProps={{
                        //     shrink: true,
                        //   }}
                        //   required
                        //   onChange={(event) => {
                        //     event.persist(event);
                        //     if (event.target.value.length > 2) {
                        //       if (!fetching) {
                        //         setFetching(true);
                        //       }
                        //       debounceLoadChargeur(event.target.value);
                        //     }
                        //   }}
                        // />
                      )
                    // <TextField
                    //   fullWidth
                    //   {...params}
                    //   required
                    //   label={formatMessage(
                    //     intl,
                    //     "create_besc_maritime_import_accordion_shippers_card_sender_label_name"
                    //   )}
                    //   error={errors.nom}
                    //   helperText={helpers.nom}
                    //   onChange={(event) => {
                    //     event.persist(event);
                    //     if (event.target.value.length > 2) {
                    //       if (!fetching) {
                    //         setFetching(true);
                    //       }

                    //       debounceLoadFournisseur(event.target.value);
                    //     }

                    //     // if (event.target.value.length > 2) {
                    //     //   setFetching(true);

                    //     // }
                    //   }}
                    //   variant="outlined"
                    // />
                  }
                ></Autocomplete>
              </FormControl>
            </Grid>
            <Grid item xs={8} sm={6} md={3}>
              <FormControl
                fullWidth
                size="small"
                required={createMode}
                className={classes.margin}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-amount">
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_shippers_card_sender_label_phone",
                  )}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  value={values.tel}
                  name="tel"
                  labelWidth={180}
                  readOnly={
                    !createMode ||
                    (role &&
                      role.user &&
                      role.user.company &&
                      role.user.company.account_local === "1" &&
                      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                        role.user.roles[0].name,
                      ) &&
                      !role.user.company.special_authorization &&
                      !role.user.company.consignataire &&
                      !role.user.company.forwarding_agent)
                  }
                  onKeyDown={(evt) => {
                    if (
                      isNaN(evt.key) &&
                      evt.key !== "." &&
                      evt.key !== "Backspace" &&
                      evt.key !== "ArrowLeft" &&
                      evt.key !== "ArrowRight" &&
                      evt.key !== "," &&
                      evt.key !== "v" &&
                      evt.key !== "V"
                    ) {
                      evt.preventDefault();
                    }
                  }}
                  error={errors.tel}
                  onChange={(event) => handleChange(event)}
                />
                <FormHelperText error>{helpers.tel}</FormHelperText>
                {/* {errors.name && <span>{errors.name.message}</span>} */}
              </FormControl>
            </Grid>
            <Grid item xs={8} sm={6} md={3}>
              <FormControl
                fullWidth
                size="small"
                className={classes.margin}
                required={createMode}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-amount">
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_shippers_card_sender_label_email",
                  )}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  value={values.email}
                  name="email"
                  labelWidth={180}
                  error={errors.email}
                  helperText={errors.helperText}
                  readOnly={
                    !createMode ||
                    (role &&
                      role.user &&
                      role.user.company &&
                      role.user.company.account_local === "1" &&
                      ["Chargeur Principal", "Sous Compte Chargeur"].includes(
                        role.user.roles[0].name,
                      ) &&
                      !role.user.company.special_authorization &&
                      !role.user.company.consignataire &&
                      !role.user.company.forwarding_agent)
                  }
                  onChange={(event) => handleChange(event)}
                />
                <FormHelperText error>{helpers.email}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={8} sm={6} md={3}>
              <FormControl
                fullWidth
                size="small"
                className={classes.margin}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-amount">
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_shippers_card_sender_label_address",
                  )}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  value={values.adresse}
                  name="adresse"
                  labelWidth={180}
                  readOnly={!createMode}
                  onChange={(event) => handleChange(event)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8} sm={6} md={3}>
              <FormControl
                fullWidth
                size="small"
                className={classes.margin}
                variant="outlined"
              >
                <Autocomplete
                  open={openT}
                  onOpen={() => {
                    setOpenT(true);
                  }}
                  onClose={() => {
                    setOpenT(false);
                    setVilles([]);
                  }}
                  loading={loadingT}
                  loadingText={formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_shippers_card_sender_label_searching",
                  )}
                  value={values.ville}
                  readOnly={!createMode}
                  hidden={!createMode}
                  size="small"
                  onChange={(event, newValue) =>
                    handleAutoCompleteChangeV(event, newValue)
                  }
                  filterOptions={(options, params) => {
                    if (!loadingT) {
                      const filtered = filter(options, params);

                      return filtered;
                    } else {
                      return [];
                    }
                  }}
                  id="free-solo-with-text-demo"
                  options={villes}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === "string") {
                      return option;
                    }

                    // Regular option

                    return option.ville + ", " + option.pays;
                  }}
                  // renderOption={(option) =>
                  //   option.ville + ', ' + option.pays
                  // }
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      label={formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_shippers_card_sender_label_town",
                      )}
                      variant="outlined"
                      required={createMode}
                      onChange={(event) => {
                        event.persist(event);

                        if (!fetching) {
                          setFetching(true);
                        }

                        debounceLoadVilles(event.target.value);
                      }}
                    />
                  )}
                ></Autocomplete>
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </div>
    </Card>
  );
}
